import { defineComponent as _defineComponent } from 'vue'
import { ref, provide, onBeforeMount, onMounted, onBeforeUnmount, computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import zh_CN from 'ant-design-vue/es/locale/zh_CN';
import en from 'ant-design-vue/es/locale/en_US';
import 'moment/dist/locale/zh-cn'
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import layout from '@/views/layout/index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

dayjs.locale('en');
const route = useRoute();

const DataMaintenance = defineAsyncComponent(
  () => import(/* webpackChunkName: "views/biz/dataMaintenance" */ '@/views/biz/dataMaintenance/index.vue')
);

const BrandMappingMaintenance = defineAsyncComponent(
  () => import(/* webpackChunkName: "views/biz/brandMappingMaintenance" */ '@/views/biz/brandMappingMaintenance/index.vue')
);

const FinancialDataMaintenance = defineAsyncComponent(
  () => import(/* webpackChunkName: "views/biz/financialDataMaintenance" */ '@/views/biz/financialDataMaintenance/index.vue')
);

const DataTaskManagement = defineAsyncComponent(
  () => import(/* webpackChunkName: "views/biz/dataTaskManagement" */ '@/views/biz/dataTaskManagement/index.vue')
);

const clsComponentMap: Record<string, any> = {
  'data-maintenance': DataMaintenance,
  'brand-mapping-maintenance': BrandMappingMaintenance,
  'financial-data-maintenance': FinancialDataMaintenance,
  'data-task-management': DataTaskManagement
};

/** 支持的 cls 应用列表（cls 参数 → 应用名称） */
const supportedClsApps: { cls: string; name: string }[] = [
  { cls: 'data-maintenance', name: 'Index数据维护' },
  { cls: 'brand-mapping-maintenance', name: 'Brand Mapping数据维护' },
  { cls: 'financial-data-maintenance', name: 'GL Account 数据维护' },
  { cls: 'data-task-management', name: '任务列表' }
];

const isIndexHtmlRoute = computed(() => route.path === '/index.html' || route.path.endsWith('/index.html'));

const currentClsComponent = computed(() => {
  const cls = (route.query.cls as string) || '';
  // 无 cls 参数时默认显示 DataTaskManagement（数据任务管理）
  if (!cls) return DataTaskManagement;
  return clsComponentMap[cls] || null;
});
const locale = ref(zh_CN);
let language = ref(localStorage.getItem('PAI-language') || 'zh_CN')
let screenWidth = ref(0);
// 提供给子组件使用
provide('sWidth', screenWidth)
onBeforeMount(() => {
  locale.value = language.value == 'zh_CN' ? zh_CN : en;
  // 日期选择器语言
  dayjs.locale(locale.value.locale);
  provide('locale', locale)
  isMac()
})
onMounted(() => {
  setInnerWidth();
  window.addEventListener('resize', setInnerWidth, false);
})
onBeforeUnmount(() => {
  window.removeEventListener('resize',setInnerWidth)
})
function isMac(){
  if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
    document.querySelector('body')?.classList.add('mac');
  } else {
    document.querySelector('body')?.classList.add('pc');
  }
}
function setInnerWidth(){
  screenWidth.value = window.innerWidth || 
  document.documentElement.clientWidth || 
  document.body.clientWidth;
}

const __returned__ = { route, DataMaintenance, BrandMappingMaintenance, FinancialDataMaintenance, DataTaskManagement, clsComponentMap, supportedClsApps, isIndexHtmlRoute, currentClsComponent, locale, get language() { return language }, set language(v) { language = v }, get screenWidth() { return screenWidth }, set screenWidth(v) { screenWidth = v }, isMac, setInnerWidth, layout }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})